// Styles
import './Login.scss';

// Libs
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

// Common
import LoginForm from '@/common/components/organisms/LoginForm/LoginForm';
// Constants
import { ROUTE_STANDALONE_LOGIN } from '@/common/constants';
// Contexts
import { useConfig } from '@/common/contexts/ConfigContext';
// HOC
import withLoginLogic from '@/common/hoc/withLoginLogic';
// Hooks
import useTheme from '@/common/hooks/useTheme';
// Assets
import { ReactComponent as ErrorIcon } from '@/materiaux/assets/icons/warning.svg';

// PropTypes
import { LoginDefaultProps, LoginPropTypes } from './Login.proptypes';

const Login = ({ errors, onSubmit }) => {
  const { t } = useTranslation();
  const { Logo } = useTheme();
  const { env } = useConfig();

  return (
    <div className="standalone-login">
      <div className="standalone-login__wrapper">
        <div className="standalone-login__description">
          <NavLink to={ROUTE_STANDALONE_LOGIN} className="site-link">
            <Logo className="site-logo" />
          </NavLink>
          <h1 className="h1" data-qa-id="title-h1">
            {t('ebat:entities:login.description.title', {
              env: t(`${env}:messages:title`),
            })}
          </h1>
          <p className="subtitle">
            {t('ebat:entities:login.description.subtitle')}
          </p>
        </div>
        <div className="standalone-login__connect">
          <div className="block-border">
            <LoginForm
              className="standalone-login__form"
              errors={errors}
              errorsIcon={<ErrorIcon />}
              onSubmit={onSubmit}
              title={t('ebat:entities:login.connect.title')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Login.defaultProps = {
  ...LoginDefaultProps,
};

Login.propTypes = {
  ...LoginPropTypes,
};

export default withLoginLogic(Login);
